'use strict';
var parent = require('../../es/object/get-own-property-descriptors');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/get-own-property-descriptors.js
// module id = 776
// module chunks = 13